<template>
  <div >
    <div class="row">
    <ul class="collapsible tasks" ref="collapsible">
        <li v-for="(activity, index) in activities" :key="activity.name">
            <div class="collapsible-header">
                {{activity.name}}
            </div>
            <div class="collapsible-body">                
              <div class="row">
                <div class="input-field col s12">
                  <input :id="'name-'+index" v-model.lazy="activity.name" type="text" class="validate" />
                  <label :for="'name-'+index" class="active">Name</label>
                </div>
              </div>
              <div class="row">
                <div class="col s6" v-for="program in programs" :key="program[0]">
                    <label>
                      <input :id="program[0]+'-'+index" type="checkbox" class="filled-in" v-model="activity.programs" :value="program[0]" />
                      <span>{{program[1].name}}</span>
                    </label>
                </div>
              </div>
              <div class="row">
                  <div class="col s3"></div>
                  <div class="col s9">
                    <a class="right" @click="remove(index)"><i class="material-icons red-text">delete</i></a>
                  </div>
              </div>
            </div>
        </li>
    </ul>
  </div>
  <div class="row">
    <div class="col s6 center-align"> 
      <a class="waves-effect waves-light btn blue " @click="add()">Add
      </a>
    </div>
    <div class="col s6 center-align"> 
      <a class="waves-effect waves-light btn green " @click="save()">Save
      </a>
    </div>
  </div>
</div>
</template>

<script>
import M from 'materialize-css'
import api from '@/api'
export default {
  name: 'activities',
  props: {
    user: Object
  },
  components: {},
  data: function () {
    return {
      activities: [],
      programs: []
    }
  },
  created () {
    this.activities = api.getActivityList()
    this.programs = api.getProgramList()
  },
  mounted () {
    M.Collapsible.init(this.$refs.collapsible, {})
  },
  methods: {
    add: function () {
      const nActivity = {
        name: 'New' + this.activities.length,
        programs: []
      }
      this.activities.push(nActivity)
    },
    remove: function (index) {
      this.activities.splice(index, 1)
    },
    save: function () {
      api.updateActivityList(this.activities)
      M.toast({html: 'Activities saved'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/coach/ActivityList.vue